export const DEFAULT_AUTH_ROLE = "MEMBER" as const;

export const JOURNEY_STEP_KEYS = {
  personalInfo: "personal-info",
  aboutYou: "about-you",
  welcome: "welcome",
  questions: "questions",
  introduction: "introduction",
  planSelection: "plan-selection",
  payment: "payment",
} as const;

export type JourneyStepKey =
  (typeof JOURNEY_STEP_KEYS)[keyof typeof JOURNEY_STEP_KEYS];

export interface JourneyStep {
  key: JourneyStepKey;
  label: string;
}

export const AUTH_ROUTE_PATHS = {
  signUp: "/signup",
  signIn: "/sign-in",
  adminLogin: "/admin/login",
  usersManagement: "/admin/users-management",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  legacyLogin: "/login",
  welcome: "/welcome",
  questions: "/questions",
  introduction: "/introduction",
  membership: "/membership",
  paymentSuccessful: "/payment-successful",
} as const;

export const getSignUpPath = () => AUTH_ROUTE_PATHS.signUp;

export const getSignInPath = () => AUTH_ROUTE_PATHS.signIn;

export const getJourneyPath = (stepKey: JourneyStepKey) => {
  switch (stepKey) {
    case JOURNEY_STEP_KEYS.welcome:
      return AUTH_ROUTE_PATHS.welcome;
    case JOURNEY_STEP_KEYS.questions:
      return AUTH_ROUTE_PATHS.questions;
    case JOURNEY_STEP_KEYS.introduction:
      return AUTH_ROUTE_PATHS.introduction;
    default:
      return AUTH_ROUTE_PATHS.signUp;
  }
};

export const getJourneyStepIndex = (
  steps: JourneyStep[],
  stepKey: JourneyStepKey,
) =>
  Math.max(
    steps.findIndex((step) => step.key === stepKey),
    0,
  );

export interface AuthContent {
  label: string;
  signInHeading: string;
  signInSubheading: string;
  signUpSubheading?: string;
  signInBackground: string;
  signInStory: string[];
  signInEmailPlaceholder: string;
  signUpHeadingStart: string;
  signUpHeadingAccent: string;
  signUpHeadingEnd: string;
  signUpSteps: JourneyStep[];
  sampleData: {
    firstName: string;
    lastName: string;
    email: string;
    phone?: string;
    location?: string;
    addressType?: string;
    companyName?: string;
    companyWebsite?: string;
    linkedin?: string;
    instagram?: string;
  };
}

export const CONTENT: AuthContent = {
  label: "Member",
  signInHeading: "Welcome Back",
  signInSubheading: "Sign in to continue.",
  signInBackground: "/Foundersbg.png",
  signInStory: [
    "Meaningful connections.",
    "Curated experiences.",
    "Better together.",
  ],
  signInEmailPlaceholder: "your.email@example.com",
  signUpHeadingStart: "Tell us a bit ",
  signUpHeadingAccent: "About",
  signUpHeadingEnd: " yourself",
  signUpSteps: [
    { key: JOURNEY_STEP_KEYS.personalInfo, label: "Personal Info" },
    { key: JOURNEY_STEP_KEYS.aboutYou, label: "Business Info" },
    { key: JOURNEY_STEP_KEYS.welcome, label: "Welcome" },
    { key: JOURNEY_STEP_KEYS.questions, label: "Questions" },
    // { key: JOURNEY_STEP_KEYS.introduction, label: "Introduction" },
  ],
  sampleData: {
    firstName: "John",
    lastName: "Doe",
    email: "john.doe@example.com",
    phone: "+1 (415) 123-4567",
    location: "San Francisco, USA",
    addressType: "Home",
    companyName: "Your Company Inc.",
    companyWebsite: "https://www.example.com",
    linkedin: "https://www.linkedin.com/in/john-doe/",
    instagram: "https://www.instagram.com/john_doe/",
  },
};
